// Versão do app - gerado automaticamente
export const APP_VERSION = '5.54'
export const BUILD_DATE = '16/08/2026, 15:19'
